import { useRef, useState } from "react";
import { Camera, Images } from "lucide-react";
import FullWidthImageLightbox from "@/components/mobile/FullWidthImageLightbox";

export default function DecoratorPhotoSlot({
  title,
  previewUrl,
  uploading,
  onCapture,
  inputKey = 0,
}) {
  const cameraRef = useRef(null);
  const galleryRef = useRef(null);
  const [lightbox, setLightbox] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file || uploading) return;
    await onCapture(file);
  };

  return (
    <div className="driver-photo-slot driver-photo-slot--compact">
      <div className="driver-photo-slot-title">{title}</div>
      {previewUrl ? (
        <button
          type="button"
          className="driver-cake-proof-hero"
          style={{ marginBottom: 10 }}
          onClick={() => setLightbox(true)}
        >
          <img src={previewUrl} alt={title} />
          <div className="driver-cake-proof-hero-label">
            Tap to view full size
          </div>
        </button>
      ) : null}
      <div key={inputKey}>
        <input
          ref={cameraRef}
          type="file"
          accept="image/*"
          capture="environment"
          disabled={uploading}
          onChange={onFile}
          style={{ display: "none" }}
          aria-hidden
        />
        <input
          ref={galleryRef}
          type="file"
          accept="image/*"
          disabled={uploading}
          onChange={onFile}
          style={{ display: "none" }}
          aria-hidden
        />
      </div>
      <div className="driver-grid-2">
        <button
          type="button"
          disabled={uploading}
          onClick={() => cameraRef.current?.click()}
          className="driver-btn driver-btn-dark"
          style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}
        >
          <Camera size={18} aria-hidden />
          {uploading ? "…" : previewUrl ? "Retake" : "Camera"}
        </button>
        <button
          type="button"
          disabled={uploading}
          onClick={() => galleryRef.current?.click()}
          className="driver-btn driver-btn-teal"
          style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}
        >
          <Images size={18} aria-hidden />
          Gallery
        </button>
      </div>

      {lightbox && previewUrl ? (
        <FullWidthImageLightbox
          src={previewUrl}
          label={title}
          alt={title}
          onClose={() => setLightbox(false)}
        />
      ) : null}
    </div>
  );
}
